<template>
    <div class=" my">
        <img src="../../assets/logotable.png" style="position:fixed;top:0.8rem;z-index:9;height:1.5rem;right:50vw;">
        <nav-bar title="活动车辆"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft" class="my-nav"/>
        <div style="height: 3rem"></div>
        <!-- 上滑进入 -->
        <cell-group title="我分享的车辆" >
            <collapse v-model="activeNames" v-if="list.length"  >
                <div v-for="(v,i) in list" :key="i">
                    <collapse-item :title="v.vehicleName" :name="i">
                        <ant-row>
                            <ant-col span="8">
                                <div>联系方式:</div>
                                <div>共有座位:</div>
                                <div>剩余座位:</div>
                                <div>出发地点:</div>
                                <div>出发时间:</div>
                            </ant-col>
                            <ant-col span="11">
                                <div>{{v.phone}}</div>
                                <div>{{v.seatNumber}}</div>
                                <div>{{v.surplusSite}}<span v-if="v.surplusSite==0" style="color:#ff0000">座位已满</span></div>
                                <div>{{v.departure}}</div>
                                <div>{{v.endTime}}</div>
                            </ant-col>
                        </ant-row>
                        <ant-row>
                            <ant-col span="8">
                                <div>备注:</div>
                            </ant-col>
                            <ant-col span="16">
                                <div>{{v.remark}}</div>
                            </ant-col>
                        </ant-row>
                        <ant-row>
                            <ant-row  v-for="(val,index) in v.vehicleUserList" :key="index+'a'" style="margin-top: 1rem">
                                <divider />
                                <ant-col :span="6">
                                    <ant-image  round width="3rem" height="3rem" :src="val.appUser.headimgurl"/>
                                </ant-col>
                                <ant-col :span="16">
                                    <div>{{val.appUser.phone}}</div>
                                    <div>{{val.appUser.userName}}</div>
                                    <div>{{val.appUser.sex==1?'男':'女'}}</div>
                                </ant-col>
                                <ant-col :span="2">
                                    <a :href="'tel:'+val.appUser.phone">
                                        <icon name="phone-circle" size="35px" color="dodgerblue"/>
                                    </a>
                                </ant-col>
                                <ant-row>
                                    <ant-col :span="6">
                                        <div>公司</div>
                                    </ant-col>
                                    <ant-col :span="16">
                                        {{val.appUser.deptName}}
                                    </ant-col>
                                </ant-row>
                                <divider />
                            </ant-row>

                        </ant-row>
                    </collapse-item>
                </div>
            </collapse>
            <empty v-else description="暂无数据"/>
        </cell-group>

        <!-- 我搭载的车辆-->
        <cell-group title="我搭载的车辆" >
            <collapse v-model="activeNamesB" v-if="listB.length">
                <div v-for="(v,i) in listB" :key="i">
                    <collapse-item :title="v.vehicleName" :name="i">
                        <ant-row>
                            <ant-col span="8">
                                <div>联系方式:</div>
                                <div>共有座位:</div>
                                <div>剩余座位:</div>
                                <div>出发地点:</div>
                                <div>出发时间:</div>
                            </ant-col>
                            <ant-col span="11">
                                <div>{{v.phone}}</div>
                                <div>{{v.seatNumber}}</div>
                                <div>{{v.surplusSite}}<span v-if="v.surplusSite==0" style="color:#ff0000">座位已满</span></div>
                                <div>{{v.departure}}</div>
                                <div>{{v.endTime}}</div>
                            </ant-col>
                        </ant-row>
                        <ant-row>
                            <ant-col span="8">
                                <div>备注:</div>
                            </ant-col>
                            <ant-col span="16">
                                <div>{{v.remark}}</div>
                            </ant-col>
                        </ant-row>
                        <ant-row>
                            <ant-col span="8">
                                <div>活动名称:</div>
                            </ant-col>
                            <ant-col span="16">
                                <div>{{v.activityName}}</div>
                            </ant-col>
                        </ant-row>
                    </collapse-item>
                </div>
            </collapse>
            <empty v-else description="暂无数据"/>
        </cell-group>

    </div>
</template>

<script>
    import service from "../../api/service";
    import {
        Cell, CellGroup, NavBar, Divider,
        Button, Form, Field, DatetimePicker,
        Popup, Toast, Collapse, CollapseItem,
        Col, Row, Image,Icon,Empty
    } from 'vant'

    export default {
        name: "myCarList",
        components: {
            Cell, CellGroup,
            NavBar, Divider,
            AntButton: Button,
            AntForm: Form,
            AntField: Field, DatetimePicker, Popup,
            Collapse, CollapseItem, AntCol: Col, AntRow: Row,AntImage: Image,Icon,Empty
        },
        data() {
            return {
                list: [],
                listB: [],
                activeNames: [],
                activeNamesB: [],
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                //我发布的车辆
                service.get('/api/VehicleUser/queryOpenMyvehicle', {
                    belongs: sessionStorage.getItem("openid")
                }).then(res => {
                    if (res.status === 200) {
                        this.list = res.data
                    }
                })
                service.get('/api/VehicleUser/myVehicle',{
                    openid: sessionStorage.getItem("openid")
                }).then(res=>{
                    if (res.status === 200){
                        this.listB = res.data
                    }
                })
            },
            //返回
            onClickLeft() {
                this.$router.push({path: '/personalCenter'})
            },
        }
    }
</script>

<style scoped>

</style>